export const CUSTOM_EVENT_DATA_FIELD_KEY_PREFIX = 'custom_event__' as const;
export const CUSTOM_EVENT_DATA_FIELD_KEY_REGEX = new RegExp(`^${CUSTOM_EVENT_DATA_FIELD_KEY_PREFIX}`);
